import request from "../utils/businessservice";
///通知类型
export function typeDictList(data) {
  return request({
    url: "/supervision/notice/typeDictList", ///测试Api地址
    method: "get",
  });
}

// 添加通知
export function addNotice(data) {
  return request({
    url: "/supervision/notice/add", ///测试Api地址
    method: "post",
    data:data
  });
}

// 修改通知
export function updateNotice(data) {
  return request({
    url: "/supervision/notice/update", ///测试Api地址
    method: "post",
    data:data
  });
}

// 通知统计
export function statisticsNotice(data) {
  return request({
    url: "/supervision/notice/statistics", ///测试Api地址
    method: "get",
    data:data
  });
}

// 通知列表
export function noticeList(data) {
  return request({
    url: "/supervision/notice/list?pageNum=" + data.pageNum + "&pageSize=20" + '&searchTime=' + data.searchTime + '&noticeTitle=' + data.title + '&emergencyStatus=' + data.emergencyStatus, ///测试Api地址
    method: "get"
  });
}

// 通知删除
export function deleteNotice(data) {
  return request({
    url: "/supervision/notice/delete?id=" + data.id, ///测试Api地址
    method: "GET"
  });
}

// 通知详情
export function noticeDetail(data) {
  return request({
    url: "/supervision/notice/" + data.id, ///测试Api地址
    method: "GET"
  });
}
